// removed by extract-text-webpack-plugin
module.exports = {"container":"cb8f459252_src-common-PageLayout-_Header_container","logo":"_92002517d1_src-common-PageLayout-_Header_logo","newsecLogo":"_37ab5e89a5_src-common-PageLayout-_Header_newsecLogo","theLittleTextThingy":"c3dc2821e6_src-common-PageLayout-_Header_theLittleTextThingy","right":"_5d9bd0955b_src-common-PageLayout-_Header_right","logout":"_6980f496fd_src-common-PageLayout-_Header_logout"};


//////////////////
// WEBPACK FOOTER
// ./src/common/PageLayout/Header.css
// module id = 998
// module chunks = 0